import React, { useState } from 'react'
import { Form, Input, Card, Typography } from 'antd'
import { useHistory } from 'react-router-dom'
import 'antd/dist/antd.css'
import './ResetPassword.scss'
import ErrorHandler from '../../utils/ErrorHandler'
import ButtonMain from '../../components/ButtonMain/ButtonMain.jsx'
import { GetResetPassword } from '../../api/ResetPassword'
import ConfirmHandler from '../../utils/ConfirmHandler'
import Loading from '../../components/Loading/Loading.jsx'

const { Title } = Typography

export default function ResetPassword () {
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [confirmModalMsg, setConfirmModalMsg] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()
  const history = useHistory()
  const ResetMethod = async () => {
    form.validateFields()
      .then(fetchData)
      .catch(error => {
        const { errorFields } = error
        const filterErrorMsg = errorFields.map(item => {
          const { errors } = item
          item.errors = [...new Set(errors)]
          return item
        })
        setIsErrorModalVisible(filterErrorMsg)
      })
  }
  async function fetchData (values) {
    setIsErrorModalVisible(false)
    const TempAccessToken = sessionStorage.getItem('TEMP_ACCESS_TOKEN')
    setIsLoading(true)
    const Reset = await GetResetPassword({ passwordVerify: values.passwordVerify, tempAccessToken: TempAccessToken })
    setIsLoading(false)
    const { rcrm } = Reset
    if (rcrm.RC === 'C01') {
      setIsModalVisible(true)
      setConfirmModalMsg('請重新登入棉花田會員')
    } else {
      switch (rcrm.RC) {
        case 'TEMP_TOKEN_IS_NOT_EXIST':
          setConfirmModalMsg('Token 已逾期或不存在。請您再次重新操作一次，謝謝您的配合')
          break
        default:
          setConfirmModalMsg('系統執行有誤，請重新再試一次，謝謝。')
          break
      }
    }
  }

  const handleOk = () => {
    setIsModalVisible(false)
    history.push('/login')
  }

  return (
    <div>
      <Card type="inner" className="restPasswordPage-basic">
      <Title level={2} className="page-title">請重新設定密碼</Title>
      {isErrorModalVisible ? <ErrorHandler errorList={isErrorModalVisible} /> : null}
        <Form
          form={form}
          name="basic"
          autoComplete="off"
        >
          <Form.Item
            label="密碼"
            name="password"
            rules={[
              {
                required: true,
                message: '密碼為必填'
              },
              {
                min: 6,
                message: '密碼須為 6-12 碼英數字混合'
              },
              {
                max: 12,
                message: '密碼須為 6-12 碼英數字混合'
              },
              {
                pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
                message: '密碼須為 6-12 英數字混合'
              }]}
          >
            <Input.Password className="input-text" placeholder="6 - 12 碼英數字混和" />
          </Form.Item>

          <Form.Item
            label="密碼確認"
            name="passwordVerify"
            rules={[
              {
                required: true,
                message: '密碼確認為必填'
              },
              {
                min: 6,
                message: '密碼確認須為 6-12 碼英數字混合'
              },
              {
                max: 12,
                message: '密碼確認須為 6-12 碼英數字混合'
              },
              {
                pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
                message: '密碼確認須為 6-12 英數字混合'
              }]}
          >
            <Input.Password className="input-text" placeholder="請再一次輸入密碼" />
          </Form.Item>
          <ButtonMain buttonType="main" onClick={ResetMethod}>確認</ButtonMain>
        </Form>
      </Card>
      <Loading isLoadingVisible={isLoading}>{isLoading}</Loading>
      {isModalVisible ? <ConfirmHandler title="提示" setModalvisible={isModalVisible} setHandleOk={handleOk} msg={confirmModalMsg} /> : null}
    </div>
  )
}
